// extracted by mini-css-extract-plugin
export var actionText = "_qv-4";
export var container = "_qv-0";
export var leftSection = "_qv-1";
export var rightSection = "_qv-2";
export var settingsButton = "_qv-6";
export var settingsIcon = "_qv-7";
export var shortcut = "_qv-5";
export var shortcutGroup = "_qv-3";